import type { PartnerSummary } from "@redotech/admin-sdk/rpc/schema/partners/shared";
import type { RedoTableColumn } from "@redotech/redo-web/arbiter-components/tables/redo-table";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { StandardRedoTableHeaderCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-header-cells";

import { formatLastActivity } from "../../onboardings/common/utils";
import { PartnerStatusBadge } from "./partner-status-badge";

const partnerTypeLabels: Record<string, string> = {
  individual: "Individual",
  app: "App",
  agency: "Agency",
};

/**
 * Column layout for the partners list view. Definitions are static —
 * they don't depend on page state — so they live in a module-level const
 * rather than being recomputed via useMemo on every render.
 */
export const PARTNERS_COLUMNS: RedoTableColumn<PartnerSummary>[] = [
  {
    key: "email",
    renderHeaderCell: () => <StandardRedoTableHeaderCell headerText="Email" />,
    renderNormalCell: ({ row }) => <RedoTableTextCell text={row.email} />,
  },
  {
    key: "name",
    renderHeaderCell: () => <StandardRedoTableHeaderCell headerText="Name" />,
    renderNormalCell: ({ row }) => <RedoTableTextCell text={row.name} />,
  },
  {
    key: "referralCode",
    renderHeaderCell: () => (
      <StandardRedoTableHeaderCell headerText="Referral code" />
    ),
    renderNormalCell: ({ row }) => (
      <RedoTableTextCell text={row.referralCode} />
    ),
  },
  {
    key: "partnerType",
    renderHeaderCell: () => <StandardRedoTableHeaderCell headerText="Type" />,
    renderNormalCell: ({ row }) => (
      <RedoTableTextCell
        text={partnerTypeLabels[row.partnerType] ?? row.partnerType}
      />
    ),
  },
  {
    key: "status",
    renderHeaderCell: () => <StandardRedoTableHeaderCell headerText="Status" />,
    renderNormalCell: ({ row }) => <PartnerStatusBadge status={row.status} />,
  },
  {
    key: "createdBy",
    renderHeaderCell: () => (
      <StandardRedoTableHeaderCell headerText="Created by" />
    ),
    renderNormalCell: ({ row }) => <RedoTableTextCell text={row.createdBy} />,
  },
  {
    key: "createdAt",
    renderHeaderCell: () => (
      <StandardRedoTableHeaderCell headerText="Created" />
    ),
    renderNormalCell: ({ row }) => (
      <RedoTableTextCell text={formatLastActivity(new Date(row.createdAt))} />
    ),
  },
];
